(function() {
  "use strict";

  angular.module("FormBuilder").directive("fbLabelDivNoMsg", fbLabelDirective);

  function fbLabelDirective() {
    return {
      restrict: "E",
      transclude: true,
      scope: {
        element: "=",
        elementIdentifier: '='
      },
      templateUrl: "common/libraries/formBuilder/fields/label-div-no-msg",
      controller: fbLabelDirectiveCtrl,
      controllerAs: "vm",
      bindToController: true
    };
  }

  function fbLabelDirectiveCtrl($scope, FormBuilderService, lodash) {
    var vm = this;
    var fbService = null;
    this.$onInit = function() {
      var formIdentifier = $scope.$parent.vm.formIdentifier;
      fbService = FormBuilderService.get(formIdentifier);
      vm.hasError = hasError;
    }

    function hasError() {
      return !lodash.isEmpty(
        fbService.elementsService.getValidationRule(vm.elementIdentifier)
      );
    }
  }
})();
